module.exports = __webpack_public_path__ + "img/SKMJ_sheet2.a59a7fc8.png";